// Centrale app-versie. APP_VERSION (patch) en APP_BUILD worden automatisch gezet bij elke build (scripts/gen-version.js).
// Verhoog major/minor handmatig bij een grote release.
export const APP_VERSION = "v1.7.178";
export const APP_BUILD = "2026-10-31 10:53";
